import { render, staticRenderFns } from "./TextNormal.vue?vue&type=template&id=656a9b2a&"
import script from "./TextNormal.vue?vue&type=script&lang=js&"
export * from "./TextNormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports